import { render, staticRenderFns } from "./AIDashboard.vue?vue&type=template&id=ee724624&scoped=true&"
import script from "./AIDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIDashboard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AIDashboard.vue?vue&type=style&index=0&id=ee724624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee724624",
  null
  
)

export default component.exports